/**
 * SEO Image Constants
 * Centralized Open Graph and social sharing image URLs for SeniorThrive
 * All images should be 1200x630px for optimal social media display
 */

const BASE_URL = 'https://seniorthrive.com';

export const OG_IMAGES = {
  // Default fallback for pages without specific OG images
  default: `${BASE_URL}/og-images/default.png`,
  
  // Homepage - Core mission and value proposition
  home: `${BASE_URL}/og-images/home.png`,
  
  // Pricing page - Free trial and value messaging
  pricing: `${BASE_URL}/og-images/pricing.png`,
  
  // Sponsorship page - Professional partnership messaging
  sponsorship: `${BASE_URL}/og-images/sponsorship.png`,
  
  // Blog/Articles - General content sharing
  blog: `${BASE_URL}/og-images/blog.png`,
  
  // Add more as needed for specific pages
} as const;

/**
 * Logo URL for structured data (schema.org)
 */
export const LOGO_URL = `${BASE_URL}/logo.png`;

/**
 * Favicon URL
 */
export const FAVICON_URL = `${BASE_URL}/favicon.ico`;
